'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');
const clsx = require('clsx');
const colord = require('colord');
const theme_Colors = require('../../../theme/Colors.cjs.js');
require('../../../theme/Shadows.cjs.js');
require('../../../theme/Typography.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  const n = Object.create(null, { [Symbol.toStringTag]: { value: 'Module' } });
  if (e) {
    for (const k in e) {
      if (k !== 'default') {
        const d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: () => e[k]
        });
      }
    }
  }
  n.default = e;
  return Object.freeze(n);
}

const React__namespace = /*#__PURE__*/_interopNamespace(React);
const clsx__default = /*#__PURE__*/_interopDefault(clsx);

var o=function(o){var t=o/255;return t<.04045?t/12.92:Math.pow((t+.055)/1.055,2.4)},t=function(t){return .2126*o(t.r)+.7152*o(t.g)+.0722*o(t.b)};function a11yPlugin(o){o.prototype.luminance=function(){return o=t(this.rgba),void 0===(r=2)&&(r=0),void 0===n&&(n=Math.pow(10,r)),Math.round(n*o)/n+0;var o,r,n;},o.prototype.contrast=function(r){void 0===r&&(r="#FFF");var n,a,i,e,v,u,d,c=r instanceof o?r:new o(r);return e=this.rgba,v=c.toRgb(),u=t(e),d=t(v),n=u>d?(u+.05)/(d+.05):(d+.05)/(u+.05),void 0===(a=2)&&(a=0),void 0===i&&(i=Math.pow(10,a)),Math.floor(i*n)/i+0},o.prototype.isReadable=function(o,t){return void 0===o&&(o="#FFF"),void 0===t&&(t={}),this.contrast(o)>=(e=void 0===(i=(r=t).size)?"normal":i,"AAA"===(a=void 0===(n=r.level)?"AA":n)&&"normal"===e?7:"AA"===a&&"large"===e?3:4.5);var r,n,a,i,e;};}

const root = "_root_1rexh_1";
const styles = {
	root: root
};

colord.extend([a11yPlugin]);
const Tag = ({ children, className, size = "small", variant = "default" }) => {
  let backgroundColor = "UiPrimaryWeaker";
  let textColor = "TextDefault";
  if (!isTagVariant(variant)) {
    backgroundColor = variant;
    const lightTextContrast = colord.colord(theme_Colors.Colors[backgroundColor]).contrast(theme_Colors.Colors.TextInverted);
    const darkTextContrast = colord.colord(theme_Colors.Colors[backgroundColor]).contrast(theme_Colors.Colors.TextStronger);
    if (lightTextContrast > darkTextContrast) {
      textColor = "TextInverted";
    } else {
      textColor = "TextStronger";
    }
  }
  return React__namespace.createElement("span", { className: clsx__default.default(styles.root, className), style: {
    "--zds-internal-tag-background": theme_Colors.Colors[backgroundColor],
    "--zds-internal-tag-text": theme_Colors.Colors[textColor]
  }, "data-size": size, "data-variant": variant, "data-zds": true }, children);
};
const tagVariants = [
  "default",
  "success",
  "error",
  "warning",
  "inverted",
  "simple"
];
const tagVariantsSet = new Set(tagVariants);
function isTagVariant(variant) {
  return tagVariantsSet.has(variant);
}

exports.Tag = Tag;
//# sourceMappingURL=Tag.cjs.js.map
